<template lang="pug">
v-app
  v-app-bar.rounded-b-xl.flex-grow-0.overflow-hidden(v-if="$vuetify.breakpoint.mdAndUp" app elevation="1" height="70")
    v-container.d-flex.justify-space-between.align-center.py-5
      img.d-md-none.d-lg-block.mr-4.re-cursor-pointer(:src="$vuetify.theme.dark ? '/static/logo-black.png' : '/static/logo-white.png'" width="80" @click="$router.push('/')")
      re-registration-status-and-switcher

  v-app-bar.rounded-b-xl.flex-grow-0.overflow-hidden.pl-2(v-else app elevation="1" height="60")
    re-registration-status-and-switcher

  v-main
    router-view

  re-cash-registers

  re-authentication-module

  re-app-update-warning

</template>
<script>
import { mapState, mapActions } from 'vuex'
import CashRegisters from './settings/CashRegisters.vue'
import RegistrationStatusAndSwitcher from './utils/RegistrationStatusAndSwitcher.vue'
import AuthenticationModule from './utils/AuthenticationModule.vue'
import AppUpdateWarning from './utils/AppUpdateWarning.vue'

export default {
  components: {
    're-cash-registers': CashRegisters,
    're-registration-status-and-switcher': RegistrationStatusAndSwitcher,
    're-authentication-module': AuthenticationModule,
    're-app-update-warning': AppUpdateWarning,
  },

  data: () => ({
    showLockDialog: false,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      organization: state => state.cashRegisters.cashRegister.organization,
      preferences: state => state.cashRegisters.cashRegister.cashRegister.data.preferences,
      appInitialized: state => state.tools.appInitialized,
    }),
  },

  created() {
    this.setGlobalLoading(true)
    this.selectCashRegister(this.cashRegister.id).then(() => {
      this.setGlobalLoading(false)
    }).catch(() => {
      this.setGlobalLoading(false)
    })

    // AppInitialize
    if (!this.appInitialized) {
      // Analytics setUserId
      this.analyticsSetUserId(this.user.phone)

      // App rate
      if (this.$isCordova()) {
        const appLaunchCount = parseInt(localStorage.getItem('rekassa.kz-tools-appLaunchCount') || 0, 10)
        const appRated = (localStorage.getItem('rekassa.kz-tools-appRated') || 'false') === 'true'
        if (!appRated && appLaunchCount > 20) {
          setTimeout(() => {
            localStorage.setItem('rekassa.kz-tools-appRated', 'true')
            window.cordova.plugins.AppReview.requestReview().catch(() => console.debug('AppReview.requestReview error'))
            this.analyticsLogEvent({ eventName: 're_appreview_showed' })
          }, 2000)
        }
      }

      // Analytics setUserProperty fdo_type
      if (this.cashRegister.status === 'REGISTERED') {
        this.analyticsSetUserProperty({ key: 'fdo_type', value: this.cashRegister.fdo })
      }

      // Geolocation coords
      if (this.$isTestMode()) {
        try {
          navigator.geolocation.getCurrentPosition((position) => {
            this.setGeolocationCoords({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            })
          })
        } catch (error) {
          console.error('Error getting geolocation coords:', error)
        }
      }

      this.setAppInitialized(true)
    }
  },

  methods: {
    ...mapActions({
      selectCashRegister: 'cashRegisters/selectCashRegister',
      analyticsSetUserProperty: 'analytics/setUserProperty',
      analyticsSetUserId: 'analytics/setUserId',
      setAppInitialized: 'tools/setAppInitialized',
      setGlobalLoading: 'tools/setGlobalLoading',
      showCashRegisterSwitch: 'tools/showCashRegisterSwitch',
      setGeolocationCoords: 'cashRegisters/setGeolocationCoords',
      showConfirm: 'confirm/showConfirm',
      analyticsLogEvent: 'analytics/logEvent',
    }),
  },
}

</script>
<style scoped lang="stylus">
.re-main-toolbar
  .router-link-active
    p, .v-icon
      color var(--v-secondary-base) !important
  a:hover, span:hover
    opacity 0.4

.re-main-bot-nav
  height 64px !important
  padding-right 16px !important
  padding-left 16px !important
  border-radius 16px 16px 0 0
  background var(--v-reForeground-base)

  .flex-1
    flex 1 !important

  .v-icon
    margin-top 12px
  p
    font-size 11px
    line-height 10px
    margin-top 3px
  a
    text-decoration none !important
  .router-link-active
    p, .v-icon
      color var(--v-secondary-base) !important

  .re-main-bot-nav-calc
    background var(--v-reForeground-lighten1)
    box-shadow 0px 1px 1px 0px #FFFFFF33 inset
    position relative
    height 68px
    bottom 5px
    padding-bottom 12px
    justify-content flex-end !important
    border-radius 10px 10px 0 0

.theme--dark
  .re-main-bot-nav-calc
    box-shadow 0px 1px 1px 0px #FFFFFF33 inset !important
.theme--light
  .re-main-bot-nav-calc
    box-shadow 0px 1px 1px 0px rgb(213, 213, 213)inset !important

header.v-app-bar:has(.re-register-header-status-NORMAL)
  @media (max-width: 959px)
    background-color #5E9CF4 !important
    background-image url(/static/wave.png)
    background-size cover

header.v-app-bar:has(.re-register-header-status-SUCCESS)
  @media (max-width: 959px)
    background-color #18AE3E !important
    background-image url(/static/wave.png)
    background-size cover

header.v-app-bar:has(.re-register-header-status-ERROR)
  @media (max-width: 959px)
    background-color #FF1957 !important
    background-image url(/static/wave.png)
    background-size cover
</style>
